import HttpClient from '../../../services/http-client';
import { IBudgetUnitFilterRequest } from '../../../../model/sge/budget-unit/request/budget-unit-filter-request';
import { IBudgetUnitAddEditRequest } from '../../../../model/sge/budget-unit/request/budget-unit-add-edit-request';
import { IBudgetUnitResponse } from '../../../../model/sge/budget-unit/response/budget-unit-response';

const defaultPath = 'BudgetUnit';

const list = async (params?: IBudgetUnitFilterRequest): Promise<IBudgetUnitResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}`,
        params
    }).then((response) => response.data);
};

const getById = async (id: number): Promise<IBudgetUnitResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${id}`
    }).then((response) => response.data);
};

const add = async (params: IBudgetUnitAddEditRequest): Promise<IBudgetUnitResponse> => {
    return await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}`,
        data: { year: params.year, code: params.code, name: params.name }
    }).then((response) => response.data);
};

const edit = async (id: number, params: IBudgetUnitAddEditRequest): Promise<IBudgetUnitResponse> => {
    return await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/${id}`,
        data: { code: params.code, name: params.name }
    }).then((response) => response.data);
};

const remove = async (id: number): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'delete',
        url: `/${defaultPath}/${id}`
    });
};

const BudgetUnitAppService = { list, getById, add, edit, remove };
export default BudgetUnitAppService;
